


























































































































































































import _ from 'lodash';
import moment from 'moment';
import {Vue, Component} from 'vue-property-decorator';
import { State, Action, namespace } from 'vuex-class';
import { ActionError as campaignStoreErr } from '@/store/campaign/types';

import { DefaultOption, TableOptionType } from '@/const/options/DefaultTableOption';

import { CurrentCampaignType, CurrentAdsetType } from '@/store/campaign/types';
import { Setting as terms } from '@/const/terms/mainTerms';
import { SetCampaign as campaignFeedback} from '@/const/terms/feedback/campaign';
import { SetAdset as adsetFeedback} from '@/const/terms/feedback/adset';


import { STATUS, STATUS_EXPLAINING } from '@/const/status';
import { ADJUSTMENT_MAP } from '@/const/options';
import { ID_TYPE, ADJUSTMENT_TYPE, INVENTORY_TYPE } from '@/const/types';
import {
    IAdsetHistoryResponse, IAdsetHistory, ModifiedListType, IAdsetModified,
} from './historyTypes';

import { TableColumn } from 'element-ui/types/table-column';
import { AdsetInfoResponse, IAdsetResponse, INativeAdsetResponse } from './editingTypes';
import { CampaignInfoResponse } from '../editingTypes';
import { AdsetResponse, IAdsetSummary, IAdsetBrief } from './types';

import { AxiosError, AxiosResponse } from 'axios';
import { ORIGIN_FORMAT } from '@/utils';

import PriceBrief from '@/components/ElementComponent/Brief/PriceBrief.vue';
import ScheduleTableSelector from '@/components/pages/adset/ScheduleTableSelector.vue';

import { ElTable } from 'element-ui/types/table';

const campaignModule = namespace('Campaign');

@Component<AdsetHistory>({
    name: 'AdsetHistory',
    components: {
        PriceBrief,
        ScheduleTableSelector,
    },
})
export default class AdsetHistory extends Vue{
    private terms = terms;

    private DateFormatDetailOrigin = ORIGIN_FORMAT.DateFormatDetailOrigin;
    private NumberFormatOrigin = ORIGIN_FORMAT.NumberFormatOrigin;
    private STATUS = STATUS;
    private STATUS_EXPLAINING = STATUS_EXPLAINING;
    private ADJUSTMENT_TYPE = ADJUSTMENT_TYPE;
    private ADJUSTMENT_MAP = ADJUSTMENT_MAP;
    private INVENTORY_TYPE = INVENTORY_TYPE;

    private isUtilsCollapsed: boolean = false;
    private loading: boolean = false;

    private tableData: IAdsetHistory[] = [];
    private tableOptions: TableOptionType = DefaultOption;
    
    @campaignModule.State(state => state.currentCampaign) private currentCampaign!: CurrentCampaignType;
    @campaignModule.State(state => state.currentAdset) private currentAdset!: CurrentAdsetType;
    @campaignModule.Action('SET_CURRENT_CAMPAIGN') private setCurrentCampaign!: any;
    @campaignModule.Action('SET_CURRENT_ADSET') private setCurrentAdset!: any;
    private adsetTableScrollTo(row: IAdsetHistory, column: any, event: Event) { // warning (native code)
        const table = this.$refs.historyTable as ElTable;
        let targetTable: HTMLElement | null | undefined = null;
        let wrapper = event.currentTarget as HTMLElement;
        let rowElement: HTMLElement | undefined = event.currentTarget as HTMLElement;
        if (rowElement.classList.contains('el-table__row')) {
            while (
                    wrapper.parentElement
                && !(
                    wrapper.parentElement.classList.contains('el-table__body-wrapper')
                    && (
                        (targetTable = wrapper.parentElement.closest('.el-table') as HTMLElement)
                        && targetTable.isSameNode(table.$el)
                    )
                )
            ) {
                wrapper = wrapper.parentElement;
            }
        } else {
            rowElement = undefined;
        }
        
        if (
            rowElement !== undefined
            && wrapper.parentElement
            && wrapper.parentElement.classList.contains('el-table__body-wrapper')
            && (targetTable = wrapper.parentElement.closest('.el-table') as HTMLElement)
            && targetTable.isSameNode(table.$el)
        ) {
            wrapper = wrapper.parentElement;
            let handler = setInterval(() => wrapper.scrollTo(wrapper.scrollLeft, (rowElement as HTMLElement).offsetTop), 10);
            setTimeout(() => {
                clearInterval(handler);
            }, 300)
        }

        this.tableData.forEach((history: IAdsetHistory) =>
            (history.adsetTableZoom = history.updateDate === row.updateDate ? !history.adsetTableZoom : false)
        );
    }
    private getHistoryResponseHandler() {
        this.loading = true;
        this.getHistoryResponse().then((res: any) => res.data)
            .then((data: IAdsetHistoryResponse[]) => {
                this.tableData = data.sort((a: IAdsetHistoryResponse, b: IAdsetHistoryResponse) => a.updateDate < b.updateDate ? -1 : 1)
                    .map((item: IAdsetHistoryResponse, index: number) => {
                        item.adsets.sort((a: IAdsetResponse,b: IAdsetResponse) => a.name < b.name ? -1 : 1);
                        const modifiedList: ModifiedListType = {} as ModifiedListType;
                        if (index !== 0) {
                            (Object.keys(item) as (keyof IAdsetHistoryResponse)[]).forEach((key: keyof IAdsetHistoryResponse) => {
                                if (key === 'adsets') {
                                    modifiedList.adsets = 
                                        item.adsets.reduce((pre: IAdsetModified, adset: IAdsetResponse) => {
                                            const compare = data[index - 1].adsets.find((compAdset: IAdsetResponse) => adset.id === compAdset.id);
                                            if (compare) {
                                                (compare.status & STATUS.ACTIVE) !== (adset.status & STATUS.ACTIVE) && (pre.status = [...pre.status, adset.id]);
                                                compare.landingUrl  !== adset.landingUrl && (pre.landingUrl = [...pre.landingUrl,   adset.id]);
                                                compare.budget      !== adset.budget     && (pre.budget     = [...pre.budget,       adset.id]);
                                                !(_.isEqual(compare.price, adset.price)) && (pre.price      = [...pre.price,        adset.id]);
                                                if (compare.type === INVENTORY_TYPE.native && adset.type === INVENTORY_TYPE.native) {
                                                    const nativeCompare = compare as INativeAdsetResponse;
                                                    const nativeAdset = adset as INativeAdsetResponse;
                                                    (nativeCompare.native_info.title !== nativeAdset.native_info.title 
                                                    || nativeCompare.native_info.description !== nativeAdset.native_info.description 
                                                    || nativeCompare.native_info.cta_text !== nativeAdset.native_info.cta_text)
                                                    && (pre.native_info = [...pre.native_info,    nativeAdset.id]);
                                                }
                                            }
                                            return pre;
                                        }, { status: [], landingUrl: [], budget: [], price: [], native_info: [] } as IAdsetModified);
                                } else if ( !(_.isEqual(data[index - 1][key], item[key])) ) {
                                    modifiedList[key as keyof AdsetInfoResponse] = true;
                                } else {
                                    modifiedList[key as keyof AdsetInfoResponse] = false;
                                }
                            })
                        } else {
                            modifiedList.adsets = { status: [], landingUrl: [], budget: [], price: [], native_info: [] } as IAdsetModified;
                        }
                        return {
                            ...item,
                            modifiedList: modifiedList,
                            adsetTableZoom: false,
                        } as IAdsetHistory;
                    })
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(adsetFeedback.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => {this.loading = false})
    }

    private getHistoryResponse() {
        return this.$http.adserverAPI.post('GetAdsetHistory', {
            adset_ids: this.currentAdset.idList,
        })
    }

    private async created() {
        if (this.$route.params.campaignID !== this.currentCampaign.id) {
            const campaignID = this.$route.params.campaignID;
            await this.$http.adserverAPI.post('GetCampaignInfo', {campaign_id: campaignID}).then((res: any) => res.data)
                .then(async (data: CampaignInfoResponse) => {
                    if (data && (data as any).result === null) {
                        throw new Error(campaignFeedback.getResponse.error.notFound);
                    }
                    try {
                        await this.setCurrentCampaign({
                            id: data.id,
                            name: data.name,
                            app: data.app,
                        });
                    } catch (err) {
                        switch (err.type) {
                            case campaignStoreErr.SET_CURRENT_CAMPAIGN:
                                throw new Error(campaignFeedback.getResponse.error.setCurrentCampaign);
                                break;
                        }
                        throw new Error(campaignFeedback.getResponse.error.fail);
                    }
                })
                .catch((err: AxiosError) => {
                    if(err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(campaignFeedback.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.$router.push({name: 'campaign'});
                    }
                    throw err;
                })
        }

        if (this.$route.params.adsetGroup !== this.currentAdset.name) {
            const groupName = this.$route.params.adsetGroup;
            await this.$http.adserverAPI.post('GetAdsetReport', {
                campaign_id: this.currentCampaign.id,
                placements: ['1','2','3','4','5','6'],
                since: moment(Date.now()).format('YYYYMMDDHH'),
                until: moment(Date.now()).format('YYYYMMDDHH'),
                page_no: 0,
            }).then((res: any) => res.data)
                .then( async (data: AdsetResponse) => {
                    const target = data.adsets.find((adset: IAdsetSummary) => adset.name === groupName)
                    if (target) {
                        try {         
                            await this.setCurrentAdset({
                                idList: target.targets.map((inv: IAdsetBrief) => inv.adset_id),
                                name: target.name
                            })
                        } catch (err) {
                            switch (err.type) {
                                case campaignStoreErr.SET_CURRENT_ADSET:
                                    this.$notify.error(adsetFeedback.currentAdset.error.fail);
                                    break;
                            }
                            throw err;
                        }
                    } else {
                        throw new Error(adsetFeedback.getResponse.error.notFound);
                    }
                })
                .catch((err: AxiosError) => {
                    if(err.response && (err.response as AxiosResponse).status !== 200) {
                        this.$notify.error(adsetFeedback.getResponse.error.fail);
                    } else {
                        this.$notify.error(err.message);
                        this.$router.push({name: 'adset', params: {campaignID: this.currentCampaign.id.toString()}});
                    }
                    throw err;
                })
        }
        if (!(this.currentAdset.idList && this.currentAdset.idList.reduce((pre: boolean, id: ID_TYPE) => (pre && (id.toString().length >= 16)), true))) {
            this.$notify.error(adsetFeedback.history.error.invalidAdset);
            this.$router.push({name: 'adset', params: {campaignID: this.currentCampaign.id.toString()}});
            return;
        }
        this.getHistoryResponseHandler();
    }
}
